/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiFlexGroup, EuiIcon } from '@elastic/eui'

import {
  getProviderIdFromRegionId,
  getProviderInfoById,
  type ProviderInfo,
} from '@modules/cloud-lib/providers'
import { Unmask } from '@modules/i18n'

type CommonProps = {
  text: 'none' | 'short' | 'long'
  showIcon: boolean
}

type IdProps = {
  id: ProviderInfo['id']
  region?: never
}

type RegionProps = {
  id?: never
  region: string
}

type Props = (IdProps | RegionProps) & CommonProps

const CloudProvider: React.FunctionComponent<Props> = ({
  id,
  region,
  text = 'short',
  showIcon = true,
}) => {
  const providerId = id ?? getProviderIdFromRegionId(region)
  const { iconType, shortTitle, longTitle } = getProviderInfoById(providerId)

  return (
    <EuiFlexGroup gutterSize='s' alignItems='center'>
      {showIcon && <EuiIcon type={iconType} size='l' aria-label={shortTitle} />}
      {text !== 'none' && <Unmask>{text === 'long' ? longTitle : shortTitle}</Unmask>}
    </EuiFlexGroup>
  )
}

export default CloudProvider
